/**
 * env - strict, fail-safe production detector for the v2 dashboard.
 *
 * Used to gate INTERNAL-ONLY UI: SQL queries, database table names, query row
 * counts, and any other data-provenance details that must never reach the
 * live deployment.
 *
 * Strict rule (per saved memory + user instruction 2026-04-27):
 *   Provenance / DB schema details are shown ONLY when the dashboard is NOT
 *   in production. Defaults to HIDDEN if env detection fails, so a
 *   misconfiguration cannot accidentally leak data shape to live.
 *
 * Treats both signals as "production":
 *   - REACT_APP_ENV_NAME === 'production'   (explicit gate, mirrors backend)
 *   - NODE_ENV === 'production'             (set by CRA's `npm run build`)
 *
 * Both unreadable → assume production (hide).
 */
function readEnv(key) {
  try {
    if (typeof process !== "undefined" && process.env) return process.env[key];
  } catch (e) { /* fall through */ }
  return undefined;
}

export function isProduction() {
  const explicit = readEnv("REACT_APP_ENV_NAME");
  if (explicit === "production") return true;
  if (explicit === "development" || explicit === "staging" || explicit === "test") return false;

  const node = readEnv("NODE_ENV");
  if (node === "production") return true;
  if (node === "development" || node === "test") return false;

  // Fail-safe: if neither signal is readable, treat as production.
  return true;
}

export function showProvenance() {
  return !isProduction();
}
